import { Modal } from 'components/ui/Modal';

interface Props {
  scenarioTitle?: string;
  targetSectionName: string;
  onKeepInCurrentSection: () => void;
  onMoveToScenarioSection: () => void;
  onClose: () => void;
}

export const AddQuestionScenarioChoiceModal = ({
  scenarioTitle,
  targetSectionName,
  onKeepInCurrentSection,
  onMoveToScenarioSection,
  onClose
}: Props) => (
  <Modal title="Scenario already in exam" onClose={onClose} boxClassName="w-[420px]">
    <div className="space-y-4">
      <p className="text-sm text-black">
      Questions from this scenario already appear in <strong>{targetSectionName}</strong>. Add this question there to keep the scenario together?
      </p>
      {scenarioTitle && (
        <p className="text-xs text-black/80">Scenario: {scenarioTitle}</p>
      )}
      <div className="flex gap-3 pt-2">
        <button type="button" className="secondaryBtn flex-1" onClick={onKeepInCurrentSection}>
          Keep
        </button>
        <button type="button" className="secondaryBtn flex-1" onClick={onMoveToScenarioSection}>
          Move
        </button>
      </div>
    </div>
  </Modal>
);
